/**
 * pages.js — Constantes de navigation EkynAir
 *
 * Pourquoi : la navigation par string litérale ('list', 'horses'...) est fragile.
 * Une faute de frappe ne génère aucune erreur et provoque un écran blanc silencieux.
 * Ces constantes remplacent tous les strings de navigation dans App.jsx et useAppState.js.
 *
 * Usage :
 *   import { PAGES } from '../constants/pages';
 *   s.setCurrentPage(PAGES.LIST);
 *   if (s.currentPage === PAGES.HORSES) ...
 */

export const PAGES = Object.freeze({
  LIST:      'list',       // Liste des sessions
  HORSES:    'horses',     // Liste des chevaux
  UPLOAD:    'upload',     // Import CSV EkynAir Breathe
  LIVE:      'live',       // Dashboard EkynAir Live
  HEALTH:    'health',     // Journal de santé
  DETAIL:    'detail',     // Fiche détail cheval
  NEW_HORSE: 'newHorse',   // Formulaire ajout cheval
  PROFILE:   'profile',    // Profil utilisateur
  ADMIN:     'admin',      // Backoffice admin
  FEEDBACK:  'feedback',   // Feedback bêta-testeurs
  CGU:       'cgu',        // Conditions générales d'utilisation (v2.0)
  FAQ:       'faq',        // FAQ
  NOTICE:    'notice',     // Notice d'utilisation
  COMPARE:   'compare',    // Comparaison multi-sessions
  // Pack juridique v1.0 — section 9 du DOCX
  MENTIONS:  'mentions',   // Mentions légales
  PRIVACY:   'privacy',    // Politique de confidentialité (RGPD)
  COOKIES:   'cookies',    // Politique de cookies
  MODERATION:'moderation', // Charte de modération et contenu utilisateur
  CGV:       'cgv',        // CGV — caché tant que v10.0 licences non déployé
  SUPPORT:   'support',    // Formulaire de support (remplace le mailto en clair)
});
